var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0c4.415 0 8 3.585 8 8s-3.585 8-8 8-8-3.585-8-8 3.585-8 8-8zm.999 11a1 1 0 10-2 0 1 1 0 002 0zm0-6a1 1 0 00-2 0v3a1 1 0 002 0V5z",
    fill: "#E04D4D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOCAwQzEyLjQxNSAwIDE2IDMuNTg1IDE2IDhDMTYgMTIuNDE1IDEyLjQxNSAxNiA4IDE2QzMuNTg1IDE2IDAgMTIuNDE1IDAgOEMwIDMuNTg1IDMuNTg1IDAgOCAwWk04Ljk5OSAxMUM4Ljk5OSAxMC40NDggOC41NTEgMTAgNy45OTkgMTBDNy40NDcgMTAgNi45OTkgMTAuNDQ4IDYuOTk5IDExQzYuOTk5IDExLjU1MiA3LjQ0NyAxMiA3Ljk5OSAxMkM4LjU1MSAxMiA4Ljk5OSAxMS41NTIgOC45OTkgMTFaTTguOTk5IDVDOC45OTkgNC40NDggOC41NTEgNCA3Ljk5OSA0QzcuNDQ3IDQgNi45OTkgNC40NDggNi45OTkgNVY4QzYuOTk5IDguNTUyIDcuNDQ3IDkgNy45OTkgOUM4LjU1MSA5IDguOTk5IDguNTUyIDguOTk5IDhWNVoiIGZpbGw9IiNFMDRENEQiLz4KPC9zdmc+Cg==";
export { SvgWarning as ReactComponent };